import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import Field from "@mirage/components/regularField/Field";
import { Grid } from "@mui/material";
import Board from "@publicPortal/components/board/Board";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import CompetentPersonsSchemeService from "@publicPortal/services/CompetentPersonsSchemeService";
import { IBcCompetentPersonSchema } from "@shared/publicportal/entities/IBcCompetentPersonSchema";
import React, { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { convertBooleanToYesNo } from "@mirage/utilities/convertBooleanToYesNo";

const service = new CompetentPersonsSchemeService();

const CompetentPersonsScheme = memo(() => {
    const { id } = useParams();
    const [schema, setSchema] = useState<IBcCompetentPersonSchema | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        service.getSchemeById(Number(id)).then((response) => {
            if (!response) {
                setLoading(false);
                return;
            }
            setSchema(response);
            setLoading(false);
        });
    }, [id]);

    if ((!schema || !schema.uniqueId) && !loading) {
        return (
            <>
                <ResponsiveAppBar />
                <Board headerText="Competent Persons Scheme not found" loadingHeaderText={loading} size="big">
                    <BackButton />
                </Board>
            </>
        );
    }

    return (
        <>
            <ResponsiveAppBar />
            <Board headerText={"Competent Persons Scheme " + (schema?.uniqueId || "(none)")} size="big" loadingHeaderText={loading}>
                <BackButton />
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
                        <Grid>
                            <Field label="Description Of Work" mode="view" value={schema?.descriptionOfWork} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Type Of Property" mode="view" value={schema?.typeOfProperty} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Address" mode="view" value={schema?.address} isLoading={loading} contentType="TEXTAREA" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Post Code" mode="view" value={schema?.postcode} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Post Town" mode="view" value={schema?.postTown} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Easting" mode="view" value={schema?.easting} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Northing" mode="view" value={schema?.northing} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="UPRN" mode="view" value={schema?.uprn} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Commissioning Required" mode="view" value={convertBooleanToYesNo(schema?.commissioningRequired)} isLoading={loading} contentType="TEXT" />
                        </Grid>
                        <Grid>
                            <Field
                                label="Commissioning Carried Out"
                                mode="view"
                                value={convertBooleanToYesNo(schema?.commissioningCarriedOut)}
                                isLoading={loading}
                                contentType="TEXT"
                            />
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }} className="grid-nextItem">
                        <Grid>
                            <Field label="Scheme" mode="view" value={schema?.scheme} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Unique ID" mode="view" value={schema?.uniqueId} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Local Authority Code" mode="view" value={schema?.localAuthorityCode} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field
                                label="Person Registration Identifier"
                                mode="view"
                                value={schema?.personRegistrationIdentifier}
                                isLoading={loading}
                                contentType="TEXT"
                                hideOnEmpty
                            />
                        </Grid>
                        <Grid>
                            <Field label="Installer Registered Name" mode="view" value={schema?.installerRegisteredName} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Certificate Reference" mode="view" value={schema?.certificateReference} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Contact Telephone Number" mode="view" value={schema?.contactTelephoneNumber} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Sender Response Email" mode="view" value={schema?.senderResponseEmail} isLoading={loading} contentType="TEXT" hideOnEmpty />
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 6, xl: 6 }} className="grid-nextItem">
                        <Grid>
                            <Field label="Date Work Started" mode="view" value={schema?.dateWorkCommenced} isLoading={loading} contentType="DATE" hideOnEmpty />
                        </Grid>
                        <Grid>
                            <Field label="Date Work Completed" mode="view" value={schema?.dateWorkCompleted} isLoading={loading} contentType="DATE" hideOnEmpty />
                        </Grid>
                    </Grid>
                </Grid>
            </Board>
        </>
    );
});

export default CompetentPersonsScheme;
